import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IdentityRoutingModule } from './identity-routing.module';
import { TokenLoginComponent } from './token-login/token-login.component';
import { OAuth2LoginCallbackComponent } from './oauth2-login-callback/oauth2-login-callback.component';
import { OAuth2LoginComponent } from './oauth2-login/oauth2-login.component';
import { FormsModule } from '@angular/forms';
// import { ThemeModule } from '../../@theme/theme.module';
import { NbActionsModule, NbAlertModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbDatepickerModule,
  NbIconModule, NbInputModule, NbLayoutModule, NbListModule, NbSelectModule, NbUserModule } from '@nebular/theme';
import { LogoutComponent } from './logout/token-logout.component';


@NgModule({
  declarations: [TokenLoginComponent, OAuth2LoginCallbackComponent, OAuth2LoginComponent, LogoutComponent],
  imports: [
    CommonModule,
    IdentityRoutingModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    NbActionsModule,
    NbUserModule,
    NbDatepickerModule,
    NbSelectModule,
    NbIconModule,
    NbAlertModule,
    NbListModule,
    NbCheckboxModule,
    FormsModule,
    // ThemeModule,
    NbLayoutModule,
  ],
})
export class IdentityModule { }
